module.exports = __webpack_public_path__ + "img/1530678882.d02867ee.jpg";